// extracted by mini-css-extract-plugin
module.exports = {"theme":"#1c64f4"};